import axios from '@/zenky'
import config from '@/config'
import cachedState from '@/cachedState'

export default {
  namespaced: true,

  state: {
    loaded: false,
    list: [],
  },

  getters: {
    loaded(state) {
      return state.loaded
    },

    offers(state) {
      return state.list
    },

    hasOffers(state, getters) {
      return getters.offers && getters.offers.length > 0
    },
  },

  mutations: {
    setLoadingState(state, value) {
      state.loaded = value
    },

    setOffers(state, offers) {
      state.list = (Array.isArray(offers) ? offers : []).filter(offer => !!offer.banners && !!offer.banners.desktop)
    },
  },

  actions: {
    loadOffers({ commit, rootGetters }, cityId) {
      return new Promise((resolve, reject) => {
        const offers = cachedState.offers()

        if (offers !== null) {
          commit('setLoadingState', true)
          commit('setOffers', offers)

          return resolve(offers)
        }

        const sorting = rootGetters['settings/homeOffers'].sorting

        let orderBy

        switch (sorting) {
          case 'sorting_asc':
            orderBy = 'sorting'
            break
          case 'sorting_desc':
            orderBy = '-sorting'
            break
          case 'asc':
            orderBy = 'created_at'
            break
          case 'desc':
          default:
            orderBy = '-created_at'
            break
        }

        const cityParams = cityId ? `&city_id=${cityId}&city_mode=default` : '';
        axios.get(`offers?with=${config.includes.offers}${cityParams}&order_by=${orderBy}`)
          .then(({ data }) => {
            commit('setLoadingState', true)
            commit('setOffers', data.data)
            resolve(data.data)
          })
          .catch(err => {
            commit('setLoadingState', true)
            commit('setOffers', [])
            reject(err)
          })
      })
    },
  },
}
